import {Injectable} from '@angular/core'; 
import { Meta, Title } from '@angular/platform-browser';

@Injectable({
    providedIn: 'root' // Add this to ensure your SEO service will be app-wide available
})
export class SEOService {
  constructor(private title: Title, private meta: Meta) { }


  updateTitle(title: string) {
    if (title !== undefined && title !== null) {
      this.title.setTitle(title);
    }
  }

  updateDescription(desc: string) {
    if (desc !== undefined && desc !== null) {
      this.meta.updateTag({ name: 'description', content: desc });
    }
  }

  updateKeywords(desc: string) {
    if (desc !== undefined && desc !== null) {
      this.meta.updateTag({ name: 'keywords', content: desc });
    }
  }

  //   OG STUFF

  updateOgTitle(desc: string) {
    if (desc !== undefined && desc !== null) {
      this.meta.updateTag({ property: 'og:title', content: desc });
    }
  }

  updateOgType(desc: string) {
    if (desc !== undefined && desc !== null) {
      this.meta.updateTag({ property: 'og:type', content: desc });
    }
  }

  updateOgDescription(desc: string) {
    if (desc !== undefined && desc !== null) {
      this.meta.updateTag({ property: 'og:description', content: desc });
    }
  }

  updateOgImage(desc: string) {
    if (desc !== undefined && desc !== null) {
      this.meta.updateTag({ property: 'og:image', content: desc });
    }
  }

  updateOgUrl(url: string) {
    if (url !== undefined && url !== null) {
      this.meta.updateTag({ property: 'og:url', content: url });
    }
  }

  // Twitter stuff

  updateTwitterCard(desc: string) {
    if (desc !== undefined && desc !== null) {
      this.meta.updateTag({ name: 'twitter:card', content: desc });
    }
  }

  updateTwitterTitle(desc: string) {
    if (desc !== undefined && desc !== null) {
      this.meta.updateTag({ name: 'twitter:title', content: desc });
    }
  }

  updateTwitterDescription(desc: string) {
    if (desc !== undefined && desc !== null) {
      this.meta.updateTag({ name: 'twitter:description', content: desc });
    }
  }

  updateTwitterImage(desc: string) {
    if (desc !== undefined && desc !== null) {
      this.meta.updateTag({ name: 'twitter:image', content: desc });
    }
  }

  updateCanonical(url: string) {
    if (url !== undefined && url !== null) {
      this.meta.updateTag({ rel: 'canonical', content: url });
    }
  }
}